import { Group, type GroupProps, Pagination } from "@mantine/core";

interface TablePaginationProps extends GroupProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function TablePagination({
  currentPage,
  totalPages,
  onPageChange,
  p = "md",
  justify = "flex-end",
  ...groupProps
}: TablePaginationProps) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <Group justify={justify} p={p} {...groupProps}>
      <Pagination value={currentPage} onChange={onPageChange} total={totalPages} size="sm" withEdges />
    </Group>
  );
}
